import { Box, Flex, H2, H3, H4 } from '@ouster/webviz-react-components';

import { Link } from 'react-router';
import { buildTalkToSalesLink } from 'src/utils/talkToSales';

import styles from '../PublicPage.module.css';
import demoStyles from './inAppDemo.module.css';
import { getInAppDemoBackgroundStyle } from './inAppDemoThumbnails';

export default function PublicSharedWithOuster() {
  return (
    <Box
      className={`${demoStyles['page-container']}`}
      data-testid="public-shared-with-ouster-root"
    >
      <H2
        fontWeight="medium"
        fontSize={30}
        data-testid="public-shared-with-ouster-title"
      >
        Get Faster Support with Direct Data Sharing
      </H2>
      <Box className={`${demoStyles['page-content']}`}>
        <Box className={demoStyles['text-area']}>
          {/* brief */}
          <Box className={`${demoStyles.brief}`}>
            <p>
              When expert assistance is needed, securely share lidar data
              directly with the Ouster support team. This enables{' '}
              <strong>
                faster diagnostics, more efficient collaboration, and quicker
                solutions.
              </strong>
              Register an organization with Ouster Studio to unlock this
              valuable support feature.
            </p>
            <Flex gap={4} alignItems="center">
              <Link
                to="/sign_up"
                className={`${styles['primary-button']}`}
                style={{
                  fontWeight: 500,
                  width: '300px',
                  justifyContent: 'center',
                }}
                data-testid="public-shared-with-ouster-signup-link"
              >
                Sign Up and Start Sharing
              </Link>
              <Link
                to="/login"
                className={`${styles['link-button-secondary']}`}
                data-testid="public-recordings-login-link"
              >
                Already a member? Log in
              </Link>
            </Flex>
          </Box>

          {/* go public */}
          <Box className={`${demoStyles.brief}`}>
            <H3 fontSize={24} fontWeight="medium">
              Experience Ouster Studio in Action
            </H3>
            <p>
              While direct sharing is available to registered organizations,
              there is still an opportunity to explore a public collection of
              lidar datasets. It is a perfect way to experience the powerful
              visualization tools and see the sensor point cloud firsthand.
            </p>
            <Link
              to="/public/sample_library/public_collection"
              className={`${styles['primary-button']}`}
              style={{
                fontWeight: 500,
                width: '300px',
                justifyContent: 'center',
              }}
              data-testid="public-shared-with-ouster-explore-link"
            >
              Explore Public Sample Data
            </Link>
          </Box>

          {/* talk to sale */}
          <Box fontSize={16} display="grid" rowGap={6} maxW="75ch">
            <H4 lineHeight={1.5} fontWeight="medium" color="gray.400">
              Ready to discuss your project needs and learn how Ouster can
              provide a tailored solution?
            </H4>
            <Link
              to={buildTalkToSalesLink('Public Shared with Ouster')}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles['primary-button']}`}
              style={{
                fontWeight: 500,
                width: '300px',
                justifyContent: 'center',
              }}
              data-testid="public-recordings-talk-to-sales-link"
            >
              Talk to Sales
            </Link>
          </Box>
        </Box>

        <Box
          className={`${demoStyles['image-area']}`}
          style={getInAppDemoBackgroundStyle('share_with_bg.png')}
        />
      </Box>
    </Box>
  );
}
